<div class="news-item" (click)="openNews(news)">
    <img class="news-image" src="{{imageService.changeImageUrl(news.photo)}}">
  <div class="news-info">
    <div class="title">{{news.name}}</div>
    <div class="description">{{news.shortDescription}}</div>
    <div class="date">{{news.date | date:" dd.MM.yyyy" }}</div>
  </div>
</div>
